module.exports = {
      id: "search-usage",
      viewBox: "0 0 512 512",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#search",
      toString: function () {
        return this.url;
      }
    }